module.exports = __webpack_public_path__ + "static/media/ui_ux_design.03aa428a.svg";